module.exports = __webpack_public_path__ + "101c291f8232cd7d994146e01166ef7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/create_workshop_info/create_workshop@3x.jpg
// module id = 647
// module chunks = 0